/* InnoGlow storefront interactions: gallery, bundle price sync, sticky ATC, reveal. */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    /* ---- Gallery thumbnails ---- */
    var main = document.getElementById("ig-gallery-main");
    var thumbs = document.querySelectorAll(".ig-gallery__thumb");
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var full = t.getAttribute("data-full");
        if (full && main) { main.removeAttribute("srcset"); main.src = full; }
        thumbs.forEach(function (x) { x.removeAttribute("aria-current"); });
        t.setAttribute("aria-current", "true");
      });
    });

    /* ---- Bundle selector -> price sync ---- */
    var radios = document.querySelectorAll('#ig-product-form input[name="id"]');
    var priceNow = document.getElementById("ig-price-now");
    var priceWas = document.getElementById("ig-price-was");
    var priceSave = document.getElementById("ig-price-save");
    var stickyPrice = document.getElementById("ig-sticky-price");
    var promocal = document.querySelector(".ig-promocal");

    function syncPrice() {
      var checked = document.querySelector('#ig-product-form input[name="id"]:checked');
      if (!checked) return;
      var now = checked.getAttribute("data-now");
      var was = checked.getAttribute("data-was");
      var save = checked.getAttribute("data-save");
      if (priceNow && now) priceNow.textContent = now;
      if (stickyPrice && now) stickyPrice.textContent = now;
      if (priceWas) { if (was) { priceWas.textContent = was; priceWas.hidden = false; } else { priceWas.hidden = true; } }
      if (priceSave) { if (save) { priceSave.textContent = save; priceSave.hidden = false; } else { priceSave.hidden = true; } }
      if (promocal && radios.length) promocal.style.display = (checked === radios[0]) ? "" : "none";
    }
    radios.forEach(function (r) { r.addEventListener("change", syncPrice); });
    syncPrice();

    /* ---- Sticky mobile ATC ---- */
    var sticky = document.getElementById("ig-sticky");
    var atc = document.getElementById("ig-atc");
    var form = document.getElementById("ig-product-form");
    var stickyAtc = document.getElementById("ig-sticky-atc");
    if (stickyAtc && form) {
      stickyAtc.addEventListener("click", function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }
    if (sticky && atc && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) sticky.classList.remove("is-visible");
          else sticky.classList.add("is-visible");
        });
      }, { rootMargin: "0px 0px -40% 0px" });
      io.observe(atc);
    }

    /* ---- Reveal on scroll ---- */
    var reveals = document.querySelectorAll(".ig-reveal");
    if (reveals.length && "IntersectionObserver" in window) {
      var ro = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("is-in"); obs.unobserve(e.target); }
        });
      }, { rootMargin: "-60px 0px" });
      reveals.forEach(function (el) { ro.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add("is-in"); });
    }

    /* ---- Lazy below-fold videos: preload=none, play only when in view ---- */
    var lazyVids = document.querySelectorAll("video[data-ig-lazyvideo]");
    if (lazyVids.length && "IntersectionObserver" in window) {
      var vo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { if (v.paused) { try { v.play(); } catch (err) {} } }
          else if (!v.paused) { v.pause(); }
        });
      }, { rootMargin: "200px 0px" });
      lazyVids.forEach(function (v) { vo.observe(v); });
    } else {
      lazyVids.forEach(function (v) { try { v.play(); } catch (err) {} });
    }

    /* ---- AJAX cart drawer (progressive enhancement; falls back to /cart) ---- */
    (function () {
      var drawer = document.getElementById("ig-drawer");
      if (!drawer) return;
      var itemsEl = document.getElementById("ig-drawer-items");
      var subEl = document.getElementById("ig-drawer-subtotal");
      var countEl = document.getElementById("ig-cart-count");
      var upsellEl = document.getElementById("ig-drawer-upsell");

      function money(c) { return (c / 100).toFixed(2).replace(".", ",") + " zł"; }
      function openD() { drawer.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false"); document.documentElement.style.overflow = "hidden"; }
      function closeD() { drawer.classList.remove("is-open"); drawer.setAttribute("aria-hidden", "true"); document.documentElement.style.overflow = ""; }
      function esc(s) { return (s || "").replace(/[&<>"]/g, function (m) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[m]; }); }

      function render(cart) {
        if (countEl) countEl.textContent = cart.item_count;
        if (subEl) subEl.textContent = money(cart.total_price);
        if (upsellEl) {
          var pid = upsellEl.getAttribute("data-product-id");
          var has = cart.items.some(function (it) { return String(it.product_id) === String(pid); });
          upsellEl.style.display = has ? "none" : "";
        }
        if (!itemsEl) return;
        if (!cart.items.length) { itemsEl.innerHTML = '<p class="ig-drawer__empty">Twój koszyk jest pusty.</p>'; return; }
        itemsEl.innerHTML = cart.items.map(function (it) {
          var v = (it.variant_title && it.variant_title !== "Default Title") ? '<div class="ig-ditem__var">' + esc(it.variant_title) + "</div>" : "";
          var img = it.image ? '<img class="ig-ditem__img" src="' + it.image + '" alt="" width="58" height="58" loading="lazy">' : "";
          return '<div class="ig-ditem">' + img +
            '<div class="ig-ditem__main"><div class="ig-ditem__name">' + esc(it.product_title) + "</div>" + v +
            '<div class="ig-ditem__qty"><button type="button" class="ig-qbtn" data-key="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="Zmniejsz ilość">&minus;</button>' +
            "<span>" + it.quantity + "</span>" +
            '<button type="button" class="ig-qbtn" data-key="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="Zwiększ ilość">+</button>' +
            '<button type="button" class="ig-ditem__rm" data-key="' + it.key + '" data-qty="0">Usuń</button></div></div>' +
            '<div class="ig-ditem__price">' + money(it.final_line_price) + "</div></div>";
        }).join("");
      }

      function getCart() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }
      function refresh(open) { return getCart().then(function (c) { render(c); if (open) openD(); }).catch(function () { if (open) window.location = "/cart"; }); }
      function add(id, qty) {
        return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: id, quantity: qty || 1 }) })
          .then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); });
      }
      function change(key, qty) {
        return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) })
          .then(function (r) { return r.json(); }).then(render);
      }

      if (typeof form !== "undefined" && form) {
        form.addEventListener("submit", function (e) {
          e.preventDefault();
          var checked = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
          if (!checked) { form.submit(); return; }
          add(checked.value, 1).then(function () { return refresh(true); }).catch(function () { form.submit(); });
        });
      }

      var headerCart = document.querySelector(".ig-header__cart");
      if (headerCart) headerCart.addEventListener("click", function (e) { e.preventDefault(); refresh(true); });

      drawer.addEventListener("click", function (e) {
        var t = e.target;
        if (t.closest("[data-ig-drawer-close]") || t.classList.contains("ig-drawer__overlay")) { closeD(); return; }
        var up = t.closest("[data-ig-add-upsell]");
        if (up) { up.disabled = true; add(up.getAttribute("data-variant-id"), 1).then(function () { return refresh(false); }).catch(function () { up.disabled = false; }); return; }
        var q = t.closest("[data-qty]");
        if (q) { change(q.getAttribute("data-key"), parseInt(q.getAttribute("data-qty"), 10)); return; }
      });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && drawer.classList.contains("is-open")) closeD(); });
    })();
  });
})();
